export const AppConstants = {
  isOrderDetailWebComponent: false
};